import { z } from 'zod';

const expenseConfigSchema = z.object({
  expenseMileageRate: z.number().nullable().optional(),
  defaultExpenseMarkupType: z.string().nullable().optional(),
  defaultExpenseMarkupPercentage: z.number().nullable().optional(),
  defaultExpenseMarkupFixedAmount: z.number().nullable().optional(),
  expenseReceiptRequiredAboveAmount: z.number().nullable().optional(),
}).passthrough();

export const expenseSchema = z
  .object({
    expenseConfig: expenseConfigSchema.nullable().optional(),
  })
  .passthrough()
  .superRefine((data, ctx) => {
    const config = data.expenseConfig;

    if (!config) return;

    if (config.expenseMileageRate !== null && config.expenseMileageRate !== undefined && config.expenseMileageRate < 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['expenseMileageRate'],
        message: 'Mileage rate cannot be negative',
      });
    }

    if (
      config.defaultExpenseMarkupType === 'percentage' &&
      (config.defaultExpenseMarkupPercentage === null || config.defaultExpenseMarkupPercentage === undefined || config.defaultExpenseMarkupPercentage <= 0)
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['defaultExpenseMarkupPercentage'],
        message: 'Markup percentage must be positive',
      });
    }

    if (
      config.defaultExpenseMarkupType === 'fixed_amount' &&
      (config.defaultExpenseMarkupFixedAmount === null || config.defaultExpenseMarkupFixedAmount === undefined || config.defaultExpenseMarkupFixedAmount <= 0)
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['defaultExpenseMarkupFixedAmount'],
        message: 'Markup amount must be positive',
      });
    }

    if (
      config.expenseReceiptRequiredAboveAmount !== null &&
      config.expenseReceiptRequiredAboveAmount !== undefined &&
      config.expenseReceiptRequiredAboveAmount < 0
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['expenseReceiptRequiredAboveAmount'],
        message: 'Receipt requirement cannot be negative',
      });
    }
  });

export type ExpenseSchemaData = z.infer<typeof expenseSchema>;
